import React from 'react';
import { cn } from '../lib/utils';
import { getPlanContentProfile } from '../lib/planContentProfile';

/** Selo +18 / Familiar — mesmo padrão do checkout e catálogo de planos. */
export default function PlanContentBadge({ plan, className, inline = true }) {
  const profile = getPlanContentProfile(plan);
  return (
    <span
      className={cn(
        'plan-content-badge',
        inline && 'plan-content-badge--inline',
        `plan-content-badge--${profile.tone}`,
        className,
      )}
      title={profile.hint}
    >
      <span className="plan-content-badge__emoji" aria-hidden>
        {profile.emoji}
      </span>
      <span className="plan-content-badge__label">{profile.badge}</span>
    </span>
  );
}
